export const MATRIX_REQUEST = 'MATRIX_REQUEST';
export const MATRIX_SUCCESS = 'MATRIX_SUCCESS';
export const MATRIX_FAIL = 'MATRIX_FAIL';